import AbstractScene from './AbstractScene.js';
import CircularAudioPlayer from '../prefabs/CircularAudioPlayer.js';
import Popup from '../prefabs/Popup.js';
import ButtonArrow from '../prefabs/buttons/ButtonArrow.js';
import EndScreen from '../prefabs/EndScreen.js';
import Menu from '../prefabs/Menu.js';


export default class Activite2 extends AbstractScene {
    constructor() {
        super({
            key: "Activite2"
        })
    }
    init(data) {
        this._init(data);
    }

    preload() {
        this._preload();
    }


    update() {
        this.player?.update();
        this.player2?.update();
        this.player3?.update();
        this.player4?.update();
    }

    create() {
        this.background = this.add.image(0, 0, 'act2Background').setOrigin(0, 0);

        let ctnt = "Une maman rorqual est perturbée par des bruits qui l’empêchent de retrouver son petit... Saurez-vous identifier ces bruits ?"

        this.popup = new Popup(this, ctnt, 'act2MissionCartouche', () => { this.firstBtn.setAlpha(1) })
        this.popup.launchAnim()

        this.firstBtn = new ButtonArrow(this, this.width - 140, this.height - 60, 204, 56, "C'est parti !", "24px", true).setAlpha(0)
        this.secondBtn = new ButtonArrow(this, this.width - 140, this.height - 60, 204, 56, "Suivant", "24px", false).setAlpha(0);
        this.questionMark = this.add.image(100, this.height - 60, 'questionIcon').setOrigin(0.5).setAlpha(0)

        this.firstBtn.setClickFunction(() => {
            this.tweens.add({
                targets: [this.popup],
                duration: 500,
                ease: 'Cubic.easeInOut',
                scale: 0,
                x: 40,
                y: this.height - 60,

                onComplete: () => {
                    this.firstBtn.setAlpha(0);
                    this.secondBtn.setAlpha(1);
                    this.popup.setAlpha(0);
                    this.questionMark.setAlpha(1);
                    this.players.forEach((player, index) => {
                        // player.setAlpha(1);
                        this.tweens.add({
                            targets: [player],
                            duration: 500,
                            ease: 'Cubic.easeInOut',
                            alpha: 1,
                            delay: index * 100,
                            onComplete: () => {
                            }
                        })

                    })

                }
            })
        })

        this.questionMark.setInteractive({ useHandCursor: true })
            .on('pointerdown', () => {
                this.popup.setAlpha(1);
                this.questionMark.setAlpha(0);
                this.tweens.add({
                    targets: [this.popup],
                    duration: 500,
                    ease: 'Cubic.easeInOut',
                    scale: 1,
                    x: this.width / 2,
                    y: this.height / 2,
                    onComplete: () => {
                        this.firstBtn.setAlpha(1);
                        this.secondBtn.setAlpha(0);
                    }
                })
            })
        this.players = []
        if (this.game.data.currentLevel === 1) {
            this.player = new CircularAudioPlayer(this, this.width / 2, this.height / 2 + 330, 'audioFull').setAlpha(0)
            this.players.push(this.player)
        } else {
            this.player = new CircularAudioPlayer(this, this.width / 2 - 450, this.height / 2 + 330, 'audioPlage').setAlpha(0)
            this.players.push(this.player)
            this.player2 = new CircularAudioPlayer(this, this.width / 2 - 150, this.height / 2 + 330, 'audioBateau').setAlpha(0)
            this.players.push(this.player2)
            this.player3 = new CircularAudioPlayer(this, this.width / 2 + 150, this.height / 2 + 330, 'audioTravaux').setAlpha(0)
            this.players.push(this.player3)
            this.player4 = new CircularAudioPlayer(this, this.width / 2 + 450, this.height / 2 + 330, 'audioSonar').setAlpha(0)
            this.players.push(this.player4)

        }
        let ctnt2 = " Quand un rorqual se cogne contre un bateau, il peut en mourir."
        this.endScreen = new EndScreen(this, ctnt2, 'act2BouteilleMessage', 'Activite2Video')
        this.endScreen.setAlpha(0);

        new Menu(this)

        this.secondBtn.setClickFunction(() => {
            this.secondBtn.setAlpha(0);
            this.questionMark.disableInteractive();
            this.players.forEach((player, index) => {
                // player.setAlpha(1);
                this.tweens.add({
                    targets: [player],
                    duration: 500,
                    ease: 'Cubic.easeInOut',
                    alpha: 0,
                    delay: index * 100,
                    onComplete: () => {
                        if (index === this.players.length - 1) {
                            this.endScreen.setAlpha(1);
                            this.endScreen.launchAnim()
                        }
                    }
                })

            })
        })
    }
}
